import React from 'react';
import { Box, Container, Typography, Link, Grid, IconButton, Divider } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

const Footer = () => {
    return (
        <Box component="footer" sx={{ bgcolor: '#1a1a1a', color: 'white', pt: 8, pb: 4, mt: 'auto' }}>
            <Container maxWidth="lg">
                <Grid container spacing={6}>
                    <Grid item xs={12} md={4}>
                        <Typography variant="h5" color="secondary" gutterBottom sx={{ fontWeight: 800 }}>
                            Early Education Nook
                        </Typography>
                        <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)', mb: 3, lineHeight: 1.8 }}>
                            A Gym for the Growing Mind.<br />
                            Empowering parents and children through revolutionary Right Brain Education techniques.
                        </Typography>
                        <Box>
                            <IconButton color="secondary" aria-label="Facebook"><FacebookIcon /></IconButton>
                            <IconButton color="secondary" aria-label="Instagram"><InstagramIcon /></IconButton>
                            <IconButton color="secondary" aria-label="LinkedIn"><LinkedInIcon /></IconButton>
                        </Box>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: 700, mb: 3 }}>
                            Explore
                        </Typography>
                        <Box display="flex" flexDirection="column" gap={1.5}>
                            <Link href="/courses" color="inherit" underline="hover" sx={{ opacity: 0.8 }}>Course Catalog</Link>
                            <Link href="/schedule" color="inherit" underline="hover" sx={{ opacity: 0.8 }}>Class Schedule</Link>
                            <Link href="/shop" color="inherit" underline="hover" sx={{ opacity: 0.8 }}>Shop Resources</Link>
                            <Link href="/login" color="inherit" underline="hover" sx={{ opacity: 0.8 }}>Parent Portal</Link>
                        </Box>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: 700, mb: 3 }}>
                            Legal & Support
                        </Typography>
                        <Box display="flex" flexDirection="column" gap={1.5}>
                            <Link href="#" color="inherit" underline="hover" sx={{ opacity: 0.8 }}>Terms of Service</Link>
                            <Link href="#" color="inherit" underline="hover" sx={{ opacity: 0.8 }}>Privacy Policy</Link>
                            <Link href="#" color="inherit" underline="hover" sx={{ opacity: 0.8 }}>Disclaimer</Link>
                            <Link href="/contact" color="inherit" underline="hover" sx={{ opacity: 0.8 }}>Contact Us</Link>
                        </Box>
                    </Grid>
                </Grid>

                <Divider sx={{ my: 4, bgcolor: 'rgba(255,255,255,0.1)' }} />

                <Box textAlign="center">
                    <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.5)' }}>
                        {'Copyright © '}
                        {new Date().getFullYear()}
                        {' Early Education Nook. All rights reserved.'}
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default Footer;